<div ktHeader #ktHeader class="header" [ngClass]="headerClasses" id="kt_header">
    <ng-container>
        <ngb-progressbar class="loading-bar" [value]="loader.progress$ | async" height="4px"></ngb-progressbar>
    </ng-container>
    <div class="container-fluid">
        <div class="row">
            <div class="col-4"></div>
            <div class="col">
                <app-context></app-context>
            </div>
            <div class="col-auto">
                <kt-topbar class="topbar"></kt-topbar>
            </div>
        </div>
    </div>
</div>
